export default "__VITE_ASSET__d4799abd__"